import React from 'react';

import type { fnGetFilteredProductLinks } from '@atlassian/global-shortcuts/types';

import { GlobalAppShortcuts } from './GlobalAppShortcutsWrapper.tsx';

export type GlobalAppShortcutsSectionProps = {
	orderedMenuConfig: { menuId: string; visible: boolean }[];
	onUpdateGetFilteredProductLinks: (fn: fnGetFilteredProductLinks) => void;
	shouldHandOverJiraShortcut: boolean;
	shouldHandOverLoomShortcut: boolean;
};

export const GlobalAppShortcutsSection = ({
	orderedMenuConfig,
	onUpdateGetFilteredProductLinks,
	shouldHandOverJiraShortcut,
	shouldHandOverLoomShortcut,
}: GlobalAppShortcutsSectionProps): React.JSX.Element => (
	<GlobalAppShortcuts
		orderedMenuConfig={orderedMenuConfig}
		onUpdateGetFilteredProductLinks={onUpdateGetFilteredProductLinks}
		shouldHandOverJiraShortcut={shouldHandOverJiraShortcut}
		shouldHandOverLoomShortcut={shouldHandOverLoomShortcut}
	/>
);
